import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { UserService } from '../shared/services/user.service';
import { urls } from '../shared/constants';

export const isGeoambienteGuard: CanActivateFn = async (route, state) => {
  // Skip admin guard if debug flag is enabled (grants admin access)
  if (environment.skipAuth) {
    return true;
  }

  const userService = inject(UserService);
  const router = inject(Router);

  try {
    await userService.requireUser();
  } catch (error) {
    console.error('[AdminGuard] Falha ao carregar usuário autenticado', error);
    router.navigate([urls.login]);
    return false;
  }

  if (userService.isGeoambiente) {
    return true;
  }

  router.navigate([urls.customerFacingDashboard], { replaceUrl: true });
  return false;
};
